import { useCallback, useEffect, useState } from "react";

/** GoTrue allows ~1 email per 60s per address (limits.rate_limit_resend). */
export const RESEND_COOLDOWN_SECONDS = 60;

/**
 * Countdown shared by the "resend email" affordances (Login / ForgotPassword).
 * The local window mirrors the server-side one so the second click never
 * reaches Supabase — a resend button that errors on retry is a dead end.
 */
export function useResendCooldown(seconds: number = RESEND_COOLDOWN_SECONDS) {
  const [secondsLeft, setSecondsLeft] = useState<number>(0);

  useEffect(() => {
    if (secondsLeft <= 0) return;
    const timeout = setTimeout(() => setSecondsLeft((prev) => prev - 1), 1000);
    return () => clearTimeout(timeout);
  }, [secondsLeft]);

  const start = useCallback(() => setSecondsLeft(seconds), [seconds]);

  return { secondsLeft, isCoolingDown: secondsLeft > 0, start };
}

export default useResendCooldown;
